/**
 * Which document served this page: the customer app's built shell, or Django's rendered template.
 *
 * The two are the same app, so nothing on screen says which one you got. That makes a bug report during the
 * migration expensive to attribute - the first question is always "were you on the shell?" - and an error-rate
 * comparison between the two impossible.
 *
 * Read from a marker in the document rather than from a cookie. The cookie says what a viewer opted into,
 * which is a different question: outside production the shell is the default and no cookie is set, so a
 * cookie would report the template for every dev and CI page load. In production Django cannot serve the
 * shell at all, so "shell" there also means CloudFront served it.
 */
const MARKER = 'meta[name="wayflyer:document"]';

export type DocumentMode = "shell" | "template";

export const getDocumentMode = (): DocumentMode =>
  document.querySelector(MARKER)?.getAttribute("content") === "shell" ? "shell" : "template";
